import { defineComponent as d, openBlock as n, createBlock as i, unref as o, mergeProps as r, withCtx as u, renderSlot as m } from "vue";
import s from "./ghl-ui.es190.js";
const f = d({
  name: "UIRadio",
  inheritAttrs: !1
}), b = d({
  ...f,
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    value: {
      type: [String, Number, Boolean]
    },
    name: {
      type: String
    },
    label: {
      type: String
    },
    checked: {
      type: Boolean
    },
    id: {
      type: String,
      required: !0
    }
  },
  emits: ["change", "checked", "value"],
  setup(e) {
    return (t, a) => (n(), i(o(s), r({
      id: e.id,
      disabled: e.disabled,
      label: e.label,
      value: e.value,
      name: e.name
    }, t.$attrs, {
      checked: e.checked,
      onChange: a[0] || (a[0] = (l) => t.$emit("change", l)),
      onChecked: a[1] || (a[1] = (l) => t.$emit("checked", l)),
      "onUpdate:value": a[2] || (a[2] = (l) => t.$emit("value", l)),
      size: "large"
    }), {
      default: u(() => [
        m(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["id", "disabled", "label", "value", "name", "checked"]));
  }
}), c = b;
export {
  c as default
};
